import { GetterTree } from "vuex";
import { PlaceState } from "@/store/place/state";
import { SignageAdapterApi } from "@vacancorp/signage.adapter.api.vacanservice.com";

export const getters: GetterTree<PlaceState, any> = {
    vacancyByPlaceIdHash:
        (state: PlaceState) =>
        (placeIdHash: string): SignageAdapterApi.ResponseGetDisplayVacancy => {
            return (
                state.displayVacancyList.find(
                    (displayVacancy: SignageAdapterApi.ResponseGetDisplayVacancy) =>
                        displayVacancy.placeIdHash === placeIdHash,
                ) || {
                    placeIdHash,
                    status: "vacant",
                    displayVacancyText: { fallbackLanguage: "ja", languageList: { ja: "空", en: "vacant" } },
                    vacancyCountText: { fallbackLanguage: "ja", languageList: { ja: "", en: "" } },
                    appearance: {
                        backgroundColor: "#ffffff",
                        textColor: "#00a29a",
                    },
                    alertList: [],
                }
            );
        },
    genderByPlaceIdHash:
        (state: PlaceState) =>
        (placeIdHash2: string) => {
            const gender:any = state.areaGenderList.find(({ placeIdHash }) => placeIdHash === placeIdHash2) ?? {placeIdHash:"",gender:""};
            return gender["gender"];
        },
};
